function Tab(settings) {

  if (!(this instanceof Tab)) {
    return new Tabs(settings);
  }

  this.all_tabs = settings.allTabs,
  this.tab_links = settings.tabLinks,
  this.tab_container = settings.tabContainer,
  this.tab = this,

  this.hideAllTabs = function () {

    let all_tabs = document.getElementsByClassName(this.all_tabs);
    let tab_links = document.getElementsByClassName(this.tab_links);

    // Removes Active class from all tabs
    for (let i=0; i < all_tabs.length; i++) {
      if (all_tabs[i].classList.contains('active')) {
        all_tabs[i].classList.remove('active');
      }
    }

    // Removes Active class from all tab navigation links
    for (let z=0; z < tab_links.length; z++) {
      if (tab_links[z].classList.contains('active')) {
        tab_links[z].classList.remove('active');
      }
    }

  },

  this.showCurrentTab = function (curr_tab, curr_hash) {

   // Loop through tabs and add active class to clicked tab and remove off currently active tab
   let all_tabs = this.all_tabs;

   all_tabs = document.getElementsByClassName(all_tabs);

    for (let i=0; i < all_tabs.length; i++) {

      const tab_id = all_tabs[i].id;

      const tab_height = all_tabs[i].clientHeight;

      all_tabs[i].parentElement.style.height = tab_height + 'px';

      if (tab_id == curr_hash) {
        all_tabs[i].classList.add('active');
        curr_tab.classList.remove('active');
      }  
    }

    //Loop through tab links and add active class to clicked tab link and remove off currently active link

    let all_tab_links = this.tab_links;

    all_tab_links = document.getElementsByClassName(all_tab_links);

    for (let p=0; p < all_tab_links.length; p++) {
       if (all_tab_links[p].hash == curr_hash) {
          all_tab_links[p].classList.add('active');
       }     
    }
  },

  this.changeTabs = function (e) {

    let active_tab = '.' + this.all_tabs + '.active';

    let curr_tab = document.querySelector(active_tab);

    //Hide all tabs before showing next
    this.hideAllTabs()

    // // Get the relvant hash from the href attribute
    const curr_hash = e.srcElement.hash;

     this.showCurrentTab(curr_tab, curr_hash);

    e.preventDefault();
  },

  this.tabClickEvent = function() {
    let tab_links = document.getElementsByClassName(this.tab_links);

    for (let i=0; i< tab_links.length; i++) {
      tab_links[i].addEventListener('click', this.changeTabs.bind(this));
    }
  }


  this.init = function() {

    this.tabClickEvent();

    const curr_active = document.getElementsByClassName(this.all_tabs);

    if (curr_active.length > 0) {

      for (let z=0; z < curr_active.length; z++) {
   
        if (curr_active[z].classList.contains('active')) {
          
          // Delay to allow for loading flow flow plugin to load 
          setTimeout(function() {
            const curr_height = curr_active[z].clientHeight

            let tab_contents = curr_active[z].parentElement;

            tab_contents.style.height = curr_height + 'px';
            tab_contents.parentElement.style.height = curr_height + 'px';

          }, 1000);    
        }  
      }
  }
 }
}

var desktop_gallery_settings = {
  allTabs: 'tab',
  tabLinks: 'tab-link',
  tabContainer: 'tab-content'
}

var desktop_gallery_tabs = new Tab(desktop_gallery_settings);
desktop_gallery_tabs.init();
